import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Injectable, Injector, inject } from "@angular/core";
import { StateService, UIRouterGlobals, UrlService } from "@uirouter/angular";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../auth.service";
import { StorageService } from "../storageService.service";
import { TrackingService } from "../tracking.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly auth = inject(AuthService);
  private readonly $state = inject(StateService);
  private readonly $url = inject(UrlService);
  private readonly storage = inject(StorageService);
  private readonly uiGlobals = inject(UIRouterGlobals);
  private readonly _injector = inject(Injector);

    private readonly _avoidRedirectError500 = [
        'r78g8omdc3.execute-api.us-west-2.amazonaws.com/prod/',
        'ftsm8zjvk7.execute-api.us-east-1.amazonaws.com/dev/',
    ];

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError((rejection) => {
                    if (rejection instanceof HttpErrorResponse) {
                        return this._handleError(rejection);
                    }
                    else
                        throwError(rejection);
                })
            );
    }

    private _handleError(rejection: HttpErrorResponse) {

        switch (rejection.status) {
            case 400:
                this._doTracking(rejection);
                break;
            case 401:
              this._handleAuthorizationError(rejection);
              break;
            case 403:
              this._go('error.403', rejection);
              break;
            case 404:
                this._doTracking(rejection);
                this._handleNotFoundError(rejection)
                break;
            case 500:
            case 502:
            case 503:
                this._doTracking(rejection);
                this._handleInternalServerError(rejection.status, rejection);
                break;
        }

        return throwError(rejection);
    }

    private _doTracking(rejection: HttpErrorResponse): void {
      const tracking = this._injector.get(TrackingService);
      tracking.trackError(rejection.status, rejection.url);
    }

    private _handleAuthorizationError(rejection: HttpErrorResponse): void {
        this.storage.session.set.lastUrl(this.$url.url());
        this.storage.session.set.lastUrlParts(this.$url.parts());
        if (rejection.url.includes('/servicedeskapi/')) {
            location.href = 'https://connect.pros.com/user/login?destination=/';
        }
        else if (!rejection.url.includes('airtrfx.com')) {
            setTimeout(() => this.auth.logout(), 1000);
        }
    }

    private _handleNotFoundError(rejection: HttpErrorResponse): void {
        if (rejection.url.includes(location.host)) {
            this._go('error.404', rejection);
        }
    }

    private _handleInternalServerError(status: 500 | 502 | 503, rejection: HttpErrorResponse): void {
        if (rejection.error?.message == 'Access Denied.') {
            this.$state.go('login');
        }
        else if(!this._avoidRedirect500(rejection.url)) {
                this._go(`error.${status}`, rejection );
        }
    }

    private _go(state: string, rejection: HttpErrorResponse) {
      if (this.uiGlobals.transition) this.uiGlobals.transition.abort();
      this.$state.go(state, { ...this.uiGlobals.params, error: rejection });
    }

    private _avoidRedirect500(url: string): boolean {
        return (this._avoidRedirectError500.find(e => url.indexOf(e) >= 0)) != undefined;
    }
}
